import { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import MapDisplay from "../../../components/atoms/MapDisplay";

function formatDateTime(isoString) {
  const date = new Date(isoString);
  return date.toLocaleString();
}

function RoutesMaps({ selectedAgent = "", users = [], permissions = {} }) {
  const [routeMarkers, setRouteMarkers] = useState([]);
  const [routePolylines, setRoutePolylines] = useState([]);

  useEffect(() => {
    if (!users || users.length === 0) {
      setRouteMarkers([]);
      setRoutePolylines([]);
      return;
    }

    const matchingUsers = users.filter(
      (user) =>
        String(user.id).trim() === String(selectedAgent).trim() && user.location,
    );

    if (matchingUsers.length === 0) {
      setRouteMarkers([]);
      setRoutePolylines([]);
      return;
    }

    const groupedByDate = matchingUsers.reduce((acc, user) => {
      const dateObj = new Date(user.date);
      dateObj.setHours(dateObj.getHours() - 6);
      const adjustedDateStr = dateObj.toISOString().split("T")[0];
      if (!acc[adjustedDateStr]) acc[adjustedDateStr] = [];
      acc[adjustedDateStr].push(user);
      return acc;
    }, {});

    const allMarkers = [];
    const allPolylines = [];

    Object.keys(groupedByDate).forEach((date) => {
      const locations = groupedByDate[date]
        .map((user) => {
          const [lat, lng] = user.location.split(",").map(Number);
          return { ...user, lat, lng };
        })
        .sort((a, b) => new Date(a.date) - new Date(b.date));

      if (locations.length === 1) {
        const only = locations[0];
        allMarkers.push({ ...only, label: "A", date: formatDateTime(only.date) });
        return;
      }

      if (locations.length < 1) return;

      const start = locations[0];
      const end = locations[locations.length - 1];
      allMarkers.push(
        { ...start, label: "A", date: formatDateTime(start.date) },
        { ...end, label: "B", date: formatDateTime(end.date) },
      );

      const rawPath = locations.map(({ lat, lng }) => ({ lat, lng }));
      allPolylines.push({ date, path: rawPath });
    });

    setRouteMarkers(allMarkers);
    setRoutePolylines(allPolylines);
  }, [users, selectedAgent]);

  return (
    <Stack>
      <MapDisplay
        zoom={12}
        centerLat={19.371267}
        centerLng={-99.174697}
        circleRadius={500}
        receive="Routes"
        selectedAgent={selectedAgent}
        users={users}
        routeMarkers={routeMarkers}
        routePolylines={routePolylines}
        permissions={permissions}
      />
    </Stack>
  );
}

export default RoutesMaps;
